/*
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-06-29 09:59:51
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-08-09 15:36:04
 */

/* eslint-disable */
// var mxgraph = require('mxgraph')({
//   mxLoadStylesheets: false,
//   mxLoadResources: false,
//   // mxBasePath: './src',
//   // mxImageBasePath: './src/images',
// })

// export const mxEvent = mxgraph.mxEvent
// export const mxClient = mxgraph.mxClient
// export const mxGraphHandler = mxgraph.mxGraphHandler
// export const mxEditor = mxgraph.mxEditor
// export const mxConstants = mxgraph.mxConstants
// export const mxUtils = mxgraph.mxUtils
// export const mxCodec = mxgraph.mxCodec
// export const mxKeyHandler = mxgraph.mxKeyHandler
// export const mxPerimeter = mxgraph.mxPerimeter
// export const mxObjectCodec = mxgraph.mxObjectCodec
// export const mxCodecRegistry = mxgraph.mxCodecRegistry

export const MxEvent = window.mxEvent
export const MxClient = window.mxClient
export const MxGraphHandler = window.mxGraphHandler
export const MxEditor = window.mxEditor
export const MxConstants = window.mxConstants
export const MxUtils = window.mxUtils
export const MxCodec = window.mxCodec
export const MxKeyHandler = window.mxKeyHandler
export const MxPerimeter = window.mxPerimeter
export const MxObjectCodec = window.mxObjectCodec
export const MxCodecRegistry = window.mxCodecRegistry
export const MxCellHighlight = window.mxCellHighlight
